document.addEventListener("DOMContentLoaded", function () {

  let throwCount = 0;
  const maxThrows = 4;           // number of balloons
  const intervalTime = 1800;     // time between throws
  const totalDuration = 8000;    // stop after 8 seconds

  const interval = setInterval(() => {
    if (throwCount >= maxThrows) return;
    throwBalloon();
    throwCount++;
  }, intervalTime);

  setTimeout(() => {
    clearInterval(interval);
  }, totalDuration);


  function throwBalloon() {

    const balloon = document.createElement("div");
    balloon.classList.add("holi-throw-balloon");

    // SVG Water Balloon
    balloon.innerHTML = `
      <svg viewBox="0 0 64 80" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="balloonGradient" cx="30%" cy="30%">
            <stop offset="0%" stop-color="white" stop-opacity="0.6"/>
            <stop offset="100%" stop-color="currentColor"/>
          </radialGradient>
        </defs>
        <path d="M32 2C20 2 8 18 8 34c0 18 16 30 24 40 8-10 24-22 24-40C56 18 44 2 32 2z"
              fill="url(#balloonGradient)"/>
      </svg>
    `;

    const fromLeft = Math.random() > 0.5;

    // random vertical start
    const startY = Math.random() * 60 + 20;
    balloon.style.top = startY + "vh";

    // random color
    balloon.style.color = randomColor();

    // random landing position
    const randomX = Math.random() * 60 + 20;
    const randomY = (Math.random() * 40) - 20;

    balloon.style.setProperty("--endX", randomX + "vw");
    balloon.style.setProperty("--curveY", randomY + "vh");

    if (fromLeft) {
      balloon.style.left = "-80px";
      balloon.classList.add("throw-left");
    } else {
      balloon.style.right = "-80px";
      balloon.classList.add("throw-right");
    }

    document.body.appendChild(balloon);

    setTimeout(() => {
      popBalloon(balloon);
    }, 1400);
  }


  function popBalloon(balloon) {

    const rect = balloon.getBoundingClientRect();

    const splash = document.createElement("div");
    splash.classList.add("holi-throw-splash");

    splash.style.left = rect.left + "px";
    splash.style.top = rect.top + "px";
    splash.style.background = balloon.style.color;

    document.body.appendChild(splash);
    balloon.remove();

    setTimeout(() => {
      splash.remove();
    }, 800);
  }


  function randomColor() {
    const colors = [
      "#ff0080",
      "#ffcc00",
      "#00c3ff",
      "#ff4d4d",
      "#8a2be2"
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }

});